import React, { useEffect, useState } from "react";
import axios from "axios";
import PrivacyModal from "../components/PrivacyModal";
import PageTitle from "../components/pageTitle.js";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const InquiryForm = () => {
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const isAdmin = sessionStorage.getItem("isAdmin") === "true";
  // const isAdmin = true;

  const [inquiries, setInquiries] = useState([]);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);

  const [form, setForm] = useState({
    file: null,
    name: "",
    email: "",
    phoneNumber: "",
    content: "",
  });

  useEffect(() => {
    if (isAdmin) {
      // 현재 경로가 /inquiry-form일 때만 리디렉션
      if (window.location.pathname === "/inquiry") {
        navigate("/admin/inquiries", { replace: true });
      }
    }
  }, [isAdmin, navigate]);

  const handleClick = async (e) => {
    e.preventDefault();
    const dto = {
      name: form.name,
      email: form.email,
      phoneNumber: form.phoneNumber,
      content: form.content,
    };

    if (form.name == null || form.name == "") {
      Swal.fire({
        icon: "warning",
        title: "입력 오류",
        text: "이름을 입력해주세요.",
      });
      return;
    }

    if (
      (form.phoneNumber == null || form.phoneNumber == "") &&
      (form.email == null || form.email == "")
    ) {
      Swal.fire({
        icon: "warning",
        title: "입력 오류",
        text: "전화번호 혹은 이메일을 입력해주세요.",
      });
      return;
    }

    if (form.content == null || form.content == "") {
      Swal.fire({
        icon: "warning",
        title: "입력 오류",
        text: "내용을 입력해주세요.",
      });
      return;
    }

    const formData = new FormData();
    formData.append(
      "dto",
      new Blob([JSON.stringify(dto)], { type: "application/json" })
    );
    if (form.file) {
      formData.append("file", form.file); // 파일도 함께
    }

    axios
      .post(`${baseUrl}/api/inquiry/form`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        Swal.fire({
          title: "등록 완료!",
          text: "문의가 성공적으로 접수되었습니다.",
          icon: "success",
          confirmButtonText: "확인",
        }).then(() => {
          navigate(0);
        });
      })
      .catch((error) => {
        console.error("에러 발생:", error);
      });
  };

  const autoHyphen = (value) => {
    value = value.replace(/[^0-9]/g, ""); // 숫자만 남기기
    if (value.length < 4) {
      return value;
    } else if (value.length < 7) {
      return value.slice(0, 3) + "-" + value.slice(3);
    } else if (value.length <= 11) {
      return value.slice(0, 3) + "-" + value.slice(3, 7) + "-" + value.slice(7);
    } else {
      return (
        value.slice(0, 3) + "-" + value.slice(3, 7) + "-" + value.slice(7, 11)
      );
    }
  };

  return (
    <div className="px-4 py-10 w-full">
      <div className="max-w-[1200px] mx-auto">
        <div>
          <PageTitle
            title={isAdmin ? "문의 목록" : "문의하기"}
            divider={false}
          />
        </div>
        {isAdmin ? (
          <>
            <table className="w-full border text-sm">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border px-2 py-1">번호</th>
                  <th className="border px-2 py-1">이메일</th>
                  <th className="border px-2 py-1">이름</th>
                  <th className="border px-2 py-1">연락처</th>
                  <th className="border px-2 py-1">내용</th>
                </tr>
              </thead>
              <tbody>
                {inquiries.map((item, idx) => (
                  <tr key={item.id}>
                    <td className="border px-2 py-1 text-center">{idx + 1}</td>
                    <td className="border px-2 py-1 text-center">
                      {item.name}
                    </td>
                    <td className="border px-2 py-1 text-center">
                      {item.email}
                    </td>
                    <td className="border px-2 py-1 text-center">
                      {item.phoneNumber}
                    </td>
                    <td className="border px-2 py-1">{item.content}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        ) : (
          <div>
            {/* 상단 탭 영역 */}
            <div className="flex items-center mb-6 border-b pb-2">
              <h2 className="text-rose-400 font-bold mr-6 border-b-2 border-pink-300 pb-1">
                문의
              </h2>
              <span className="text-gray-400">나의 문의/신청 내역</span>
            </div>

            <p className="text-sm sm:text-base text-gray-600 mb-8 ml-2 sm:ml-4 whitespace-nowrap tracking-tight">
              • &nbsp; 궁금한 점이나 고민이 있으시다면 언제든지 문의주세요💕
            </p>

            <form onSubmit={handleClick} className="space-y-8">
              <div className="bg-[#fafafa] p-6 space-y-8 border border-gray-100">
                {/* 이름 */}
                <div className="grid grid-cols-[40px_1fr] sm:grid-cols-[150px_1fr] items-center gap-x-4 sm:gap-x-6">
                  <label className="text-sm sm:text-base text-right">
                    이름
                  </label>
                  <input
                    className="border px-4 py-2 rounded w-full sm:w-64"
                    placeholder="이름 입력"
                    onChange={(e) =>
                      setForm((prev) => ({ ...prev, name: e.target.value }))
                    }
                  />
                </div>

                {/* 연락처 */}
                <div className="grid grid-cols-[40px_1fr] sm:grid-cols-[150px_1fr] items-center gap-x-4 sm:gap-x-6">
                  <label className="text-sm sm:text-base text-right ">
                    연락처
                  </label>
                  <input
                    className="border px-4 py-2 rounded w-full sm:w-64"
                    placeholder="010-xxxx-xxxx"
                    value={form.phoneNumber || ""}
                    onChange={(e) => {
                      const formatted = autoHyphen(e.target.value);
                      setForm((prev) => ({ ...prev, phoneNumber: formatted }));
                    }}
                  />
                </div>

                {/* 이메일일 */}
                <div className="grid grid-cols-[40px_1fr] sm:grid-cols-[150px_1fr] items-center gap-x-4 sm:gap-x-6">
                  <label className="text-sm sm:text-base text-right ">
                    이메일
                  </label>
                  <input
                    className="border px-4 py-2 rounded w-full sm:w-64"
                    placeholder="abc@gmail.com"
                    onChange={(e) =>
                      setForm((prev) => ({ ...prev, email: e.target.value }))
                    }
                  />
                </div>
                {/* 질문입력 */}
                <div className="grid grid-cols-[40px_1fr] sm:grid-cols-[150px_1fr] items-center gap-x-4 sm:gap-x-6">
                  <label className="text-sm sm:text-base text-right">
                    질문 입력
                  </label>
                  <textarea
                    className="border px-4 py-2 rounded h-72 w-full"
                    placeholder="내용을 입력해주세요."
                    onChange={(e) =>
                      setForm((prev) => ({ ...prev, content: e.target.value }))
                    }
                  />
                </div>

                <hr className="border-gray-200" />

                {/* 파일등록 */}
                <div className="grid grid-cols-[40px_1fr] sm:grid-cols-[150px_1fr] items-center gap-x-4 sm:gap-x-6">
                  <label className="text-right pt-2">사진 등록</label>
                  <div>
                    <label className="w-16 h-16 border border-dashed border-gray-300 rounded flex items-center justify-center cursor-pointer hover:border-rose-300 transition">
                      <input
                        type="file"
                        className="hidden"
                        onChange={(e) =>
                          setForm((prev) => ({
                            ...prev,
                            file: e.target.files[0],
                          }))
                        }
                      />
                      <span className="text-2xl text-gray-400">📎</span>
                    </label>
                  </div>
                </div>
              </div>

              {/* 개인정보 동의 */}
              <div className="mt-6 border-t pt-4">
                <div className="flex items-center">
                  <input type="checkbox" required className="mr-2" />
                  <span className="text-sm">
                    개인정보 수집 및 이용에 동의합니다.{" "}
                    <span className="text-rose-300">*</span>
                  </span>
                  <button
                    type="button"
                    onClick={() => setShowPrivacyModal(true)}
                    className="ml-2 text-blue-500 underline text-sm hover:text-blue-700">
                    내용보기
                  </button>
                </div>

                <div className="flex justify-end gap-2 mt-6">
                  <button
                    type="reset"
                    className="px-4 py-2 rounded bg-gray-100 hover:bg-gray-200">
                    취소
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 rounded bg-pink-300 text-white hover:bg-pink-300">
                    등록
                  </button>
                </div>
              </div>
            </form>

            {showPrivacyModal && (
              <PrivacyModal onClose={() => setShowPrivacyModal(false)} />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default InquiryForm;
